import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { Navigate, Outlet } from "react-router-dom"
import { getCurrentUser } from "@aws-amplify/auth";
import { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";
import { AuthProvider } from "@/contexts/auth-context";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function ProtectedRoute() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  useEffect(() => {
    const checkUser = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch (err) {
        console.log(err)
        setIsAuthenticated(false);
      }
    };
    checkUser();
  }, []);


  if (isAuthenticated === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  return isAuthenticated ? <AuthProvider><Outlet /></AuthProvider> : <Navigate to="/login" />;
}